import React from 'react';
import tpl from '../templates/payments-page';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'cash-desk'
        };
    }

    static displayName = 'Payments.Views.Main';
}
